import { render, staticRenderFns } from "./CorpsWalletSummary.vue?vue&type=template&id=1a696e7a&scoped=true"
import script from "./CorpsWalletSummary.vue?vue&type=script&lang=js"
export * from "./CorpsWalletSummary.vue?vue&type=script&lang=js"
import style0 from "./CorpsWalletSummary.vue?vue&type=style&index=0&id=1a696e7a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a696e7a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VDataTable,VIcon,VSelect,VSimpleTable,VSpacer})
